import { addListener, call, dispatch, postMessage, removeListener } from './core'
import { callBrowser } from './features/callBrowser'
import { callCenter } from './features/callCenter'
import { changeDebitCardPincode } from './features/changeDebitCardPincode'
import { changeStatusBar } from './features/changeStatusBar'
import { closeWebView } from './features/closeWebView'
import { finGetLineInfo } from './features/finGetLineInfo'
import { getAddress } from './features/getAddress'
import { getBank } from './features/getBank'
import { getContact } from './features/getContact'
import { getMyAccount } from './features/getMyAccount'
import { getNativeInfo } from './features/getNativeInfo'
import { getWithdrawalAccount } from './features/getWithdrawalAccount'
import { getYearMonth } from './features/getYearMonth'
import { navigateTo } from './features/navigateTo'
import { notificationExposedTime } from './features/notificationExposedTime'
import { onBackPressed } from './features/onBackPressed'
import { requestAuth } from './features/requestAuth'
import { requestPinAuth } from './features/requestPinAuth'
import { requestRefreshAuth } from './features/requestRefreshAuth'
import { sendData } from './features/sendData'
import { sendLogEvent } from './features/sendLogEvent'
import { setDebitCardPincode } from './features/setDebitCardPincode'
import { shareContent } from './features/shareContent'
import { showNotification } from './features/showNotification'
import { vibrate } from './features/vibrate'
import { init } from './init'

const bridge = {
  init,
  /**
   * Features
   */
  getNativeInfo,
  vibrate,
  showNotification,
  shareContent,
  getBank,
  getContact,
  getMyAccount,
  getAddress,
  navigateTo,
  changeStatusBar,
  getWithdrawalAccount,
  getYearMonth,
  onBackPressed,
  closeWebView,
  callCenter,
  requestPinAuth,
  requestAuth,
  notificationExposedTime,
  setDebitCardPincode,
  requestRefreshAuth,
  changeDebitCardPincode,
  sendLogEvent,
  finGetLineInfo,
  callBrowser,
  sendData,
  /**
   * Private
   */
  _dispatchEvent: dispatch,
  _call: call,
  _addListener: addListener,
  _removeListener: removeListener,
  _postMessage: postMessage,
}

export default bridge
